// extracted by mini-css-extract-plugin
module.exports = {"dossier-blocks":"dossier_dossier-blocks___FmZc"};